<template>
  <PullRefresh v-model="refresh" @refresh="onRefresh" :style="{ 'min-height': minHeight }">
    <!-- 下拉提示 -->
    <template #pulling>
      <Loading type="spinner" />
    </template>

    <!-- 释放提示 -->
    <template #loosing>
      <Loading type="spinner" />
    </template>

    <!-- 加载提示 -->
    <template #loading>
      <Loading type="spinner" />
    </template>
    <slot />
  </PullRefresh>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { PullRefresh, Loading } from 'vant'

const props = defineProps({
  minHeight: {
    // 下拉区域始终为全屏的高度
    type: String,
    default: 'calc(100vh)'
  },
  refreshing: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['onRefresh', 'update:refreshing'])

const refresh = computed({
  get: () => props.refreshing,
  set: (val) => {
    emits('update:refreshing', val)
  }
})

const onRefresh = () => {
  emits('onRefresh')
}
</script>

<style lang="less" scoped>
.pull_to_refresh {
  height: 100%;
}
</style>
